import { downloadPost } from '../../../../api/api';

export const getReport = async (request) => {
  return await downloadPost(`Reports/GetReport`, request);
};
